import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModule, Form } from '@domain-group/suit-theme'

const Billing = (props) => {
  const { providerForm } = props

  const {
    entityState: {
      billing_start_date,
      last_billed_at,
    },
    handlers,
  } = providerForm

  return (
    <DashboardModule title="Billing Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Start Date">
            <input
              name="billing_start_date"
              type="date"
              value={billing_start_date}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Last Billed at" marginTop={['large', 0]}>
            <input
              name="last_billed_at"
              type="datetime-local"
              value={last_billed_at}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

Billing.propTypes = {
  providerForm: PropTypes.object.isRequired,
}

export default Billing
